export default __webpack_public_path__ + "static/media/diary-screenshot-01.704259ee.png";